// extracted by mini-css-extract-plugin
module.exports = {"rubricBlock":"QuestionRubricBlockDisplay__rubricBlock___je-kl"};